import React from 'react';

import styles from './email-tag.scss';

const EmailChipItem = (props) => {
    const { email, handleDelete, valid } = props;
    const classNames = `${styles.tagItem} ${valid ? '' : 'error'}`;
    return (
        <span className={classNames} key={email}>
            {email}
            <button
                type="button"
                className="button"
                onClick={() => handleDelete(email, valid)}
            >
                &times;
            </button>
        </span>
    );
};

export default EmailChipItem;
